import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLanguage } from "../../../contexts/LanguageContext";

/** Retire un éventuel emoji décoratif en tête de chaîne (contenu CMS) pour un rendu typographique sobre */
const stripLeadingEmoji = (str = "") =>
  str.replace(/^[\p{Extended_Pictographic}️\s]+/gu, "");

const panelVariants = {
  hidden: { opacity: 0, y: 24 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.55, ease: [0.22, 1, 0.36, 1] },
  },
};

/**
 * Bande de clôture décisive avant le footer : une photo plein cadre en
 * dégradé sombre plutôt qu'un aplat de couleur (le cliché n°1 des bandeaux
 * CTA génériques) — le contraste vient de la lumière de la photo, pas d'un
 * bloc de couleur plaqué.
 */
const FinalCtaSection = () => {
  const { t } = useLanguage();
  return (
    <section className="py-12 sm:py-16 md:py-20">
      <motion.div
        className="relative overflow-hidden rounded-2xl min-h-[340px] sm:min-h-[300px] flex items-center"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-60px" }}
        variants={panelVariants}
      >
        <img
          src="/photo_bg/pates.png"
          alt=""
          aria-hidden
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
          decoding="async"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-ink-950 via-ink-950/85 to-ink-950/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink-950/60 via-transparent to-transparent" />
        <div className="grain-overlay" aria-hidden />

        <span
          className="hidden sm:block absolute -top-6 right-4 lg:right-8 font-display text-8xl lg:text-9xl font-medium text-white/[0.05] select-none pointer-events-none leading-none"
          aria-hidden
        >
          07
        </span>

        <div className="relative w-full px-6 sm:px-12 lg:px-16 py-14 sm:py-16 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-8">
          <div className="max-w-xl">
            <p className="text-ember-400 text-xs sm:text-sm font-semibold uppercase tracking-[0.2em] mb-4">
              {t("worldMenus")}
            </p>
            <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-white leading-[1.1] mb-4">
              {stripLeadingEmoji(t("readyToCulinaryAdventure"))}
            </h2>
            <p className="text-ink-200 text-base sm:text-lg max-w-md">
              {t("joinCommunityTransform")}
            </p>
          </div>

          <Link
            to="/auth"
            className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-md bg-ember-500 text-ink-950 font-semibold text-base whitespace-nowrap transition-colors duration-150 hover:bg-ember-400 shrink-0"
          >
            {stripLeadingEmoji(t("createFreeAccount"))}
            <span aria-hidden>→</span>
          </Link>
        </div>
      </motion.div>
    </section>
  );
};

export default FinalCtaSection;
